import { axios } from '@/plugins/axios';
import LogsID from '@/enum/Logs.enum';
import _ from 'lodash';

export function logAcces(code: LogsID, complement: string | null = null) {
	if (!_.isEmpty(code)) {
		const url = '/aat-api/traceAcces?codeAcces=' + code;
		const version = process.env.VUE_APP_VERSION;
		if (!_.isEmpty(complement)) {
			axios.post(url, version + ' : ' + complement);
		} else {
			axios.post(url, version);
		}
	}
}
